module.exports = __webpack_public_path__ + "static/media/ThemeBox.b508318c.svg";